
define('text!pages/help/help_page_content_template.html',[],function () { return '<h1>Miten käytän tätä sovellusta?</h1>\r\n<p>Klikkaa alla olevaa linkkiä lukeaksesi sovelluksen ohjekirjan.</p>\r\n<p><a href="https://keskogroup.sharepoint.com/sites/k-netti-ohjeet/SitePages/Markkinointin%C3%A4yt%C3%B6t-(DS).aspx" target="_blank">Sovelluksen ohjekirja</a></p>\r\n';});

